import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface HeroSectionProps {
  onBookCall: () => void;
}

const HeroSection = ({ onBookCall }: HeroSectionProps) => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-primary/95 to-secondary text-primary-foreground py-20 lg:py-28">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, currentColor 1px, transparent 0)`,
          backgroundSize: '32px 32px'
        }} />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-6">
            <Icon name="SparklesIcon" size={20} variant="solid" className="text-accent" />
            <span className="text-sm font-semibold font-body">Standards-Led Assessment & Recognition</span>
          </div>
          
          <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold font-headline mb-6 leading-tight">
            Defining What Good AI Leadership Looks Like
          </h1>
          
          <p className="text-lg lg:text-xl text-primary-foreground/90 mb-8 max-w-3xl mx-auto font-body leading-relaxed">
            We assess, benchmark, and recognise organisations that demonstrate maturity in AI leadership and adoption. Recognition is earned through evidence-based evaluation against defined standards.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={onBookCall}
              className="px-8 py-4 bg-accent text-accent-foreground rounded-lg font-semibold font-cta text-base hover:bg-accent/90 transition-all duration-300 shadow-strong hover:shadow-xl hover:-translate-y-0.5 flex items-center gap-2"
            >
              Start Diagnostic
              <Icon name="ArrowRightIcon" size={20} variant="outline" />
            </button>
            
            <button
              onClick={() => document.getElementById('methodology')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-4 bg-white/10 backdrop-blur-sm text-primary-foreground rounded-lg font-semibold font-cta text-base hover:bg-white/20 transition-all duration-300 flex items-center gap-2"
            >
              Explore Assessment Criteria
              <Icon name="ChevronDownIcon" size={20} variant="outline" />
            </button>
          </div>
          
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="text-3xl font-bold font-headline mb-2">85%</div>
              <div className="text-sm text-primary-foreground/80 font-body">AI Projects Fail Due to Leadership Gaps</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold font-headline mb-2">Independent</div>
              <div className="text-sm text-primary-foreground/80 font-body">Standards-Based Assessment</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold font-headline mb-2">Evidence</div>
              <div className="text-sm text-primary-foreground/80 font-body">Recognition Through Maturity</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;